const RegisterInterestPlacements = {
  AFTER_SELECT_KPIS: "afterSelectKPIs",
  AFTER_METRICS: "afterMetrics",
  AFTER_SELECT_CHALLENGES: "afterSelectChallenges"
} as const;

const ALL = Object.values(RegisterInterestPlacements);

export default { ...RegisterInterestPlacements, ALL };
